import { isShowZhiGuangTong } from '@components/LocalMerchant/ZhiGuangTong/util'
import { PRODUCT_STANDARD_PRO } from '@constant'
import {
  isStandard,
  isUltimate,
  isWeddingDressPhotoProperty,
  isWeddingPlanProperty
} from '@merchant-backend/util'
import { getProTitle, goPayment } from '@util'
import cls from 'classnames'
import { Button, Modal } from 'hljd'
import React, { Component } from 'react'
import { FUNC } from './constant'
import style from './index.module.less'
import VersionItem from './versionItem'

class VersionBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      protocol: {}
    }
  }

  handleOk = () => {
    const _isUltimate = isUltimate()
    const _isStandard = isStandard()
    const { type, fee } = this.props
    const title = type === 'pro' ? `购买${getProTitle()}` : '购买店铺标准版'
    let product_id = '50'
    if (!_isUltimate && !_isStandard) {
      product_id = type === 'pro' ? '50' : '197'
    }
    if (_isStandard) {
      product_id = type === 'pro' ? PRODUCT_STANDARD_PRO : '197'
    }
    const apiName =
      type === 'pro'
        ? '/p/wedding/index.php/admin/APIMerchantPro/pay'
        : '/p/wedding/index.php/admin/APIMerchantStandard/pay'

    this.setState({
      visible: false
    })
    goPayment({ title, fee, product_id, apiName })
  }

  onPurchase = () => {
    const {
      type,
      standard_to_flagship,
      is_buy_flagship,
      is_buy_standard,
      protocol
    } = this.props
    const _isStandard = isStandard()

    if (type === 'pro' && is_buy_flagship == 0) {
      this.setState({
        visible: true,
        protocol
      })
      return false
    }

    if (
      type === 'pro' &&
      _isStandard &&
      standard_to_flagship.is_buy_standard_to_flagship == 0
    ) {
      this.setState({
        visible: true,
        protocol: standard_to_flagship.protocol
      })
      return false
    }

    if (type === 'standard' && is_buy_standard == 0) {
      this.setState({
        visible: true,
        protocol
      })
      return false
    }

    this.handleOk()
  }

  render() {
    const { visible, protocol } = this.state
    const { type, fee, coupon = {}, is_coupon } = this.props
    const { coupon_type, gift_day, money_value } = coupon
    const _isStandard = isStandard()
    const isWedding = isWeddingDressPhotoProperty() || isWeddingPlanProperty()
    const _isShowZhiGuangTong = isShowZhiGuangTong()
    let btnName = '立即开通'
    if (_isStandard) {
      btnName = '立即续费'
    }
    if (_isStandard && type === 'pro') {
      btnName = '立即升级'
    }

    return (
      <div className={style['version-box']}>
        <div
          className={cls(style['version-box-header'], {
            [style['version-box-header-pro']]: type === 'pro'
          })}
        >
          <h3 className={style['header-title']}>
            {type === 'pro' ? '商家服务（付费）' : '标准版'}
          </h3>
          <p className={style['header-tip']}>
            {type === 'pro'
              ? '深度精细化运营，全链路营销获客'
              : '轻量级营销工具，助力商家实现运营差异化'}
          </p>
          <div className={style['price-box']}>
            <span className={style.price}>{fee}</span>
            <span className={style.yuan}>元/年</span>
            {type === 'pro' &&
              is_coupon > 0 && (
                <span className={style.day}>
                  {coupon_type &&
                    (coupon_type == 2 ? (
                      <span className="sub-price">多送{gift_day}天</span>
                    ) : (
                      <span className="sub-price">限时减 ￥{money_value}</span>
                    ))}
                </span>
              )}
          </div>
          <div className={style['purchase-btn']} onClick={this.onPurchase}>
            {btnName}
          </div>
        </div>
        <div className={style['version-box-body']}>
          {FUNC.map((item, index) => {
            if (item.key === 'kezi' && !isWedding) {
              return null
            }
            if (
              (item.key === 'marketDataAnalysis_basic' ||
                item.key === 'marketDataAnalysis_detail') &&
              !_isShowZhiGuangTong
            ) {
              return null
            }
            if (item.key === 'marketDataAnalysis_basic' && type === 'pro') {
              return null
            }
            if (
              item.key === 'marketDataAnalysis_detail' &&
              type === 'standard'
            ) {
              return null
            }
            return <VersionItem item={item} key={index} type={type} />
          })}
        </div>
        <Modal
          title={protocol.protocol_title}
          visible={visible}
          onOk={this.handleOk}
          onCancel={() => this.setState({ visible: false })}
          keyboard={false}
          width={700}
          wrapClassName={style.versionBox}
          footer={[
            <Button type="primary" key="ok" onClick={this.handleOk}>
              我同意遵守协议并继续下单
            </Button>
          ]}
        >
          <div
            style={{
              maxHeight: '500px',
              overflow: 'hidden',
              overflowY: 'auto'
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: protocol.protocol_content }}
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default VersionBox
